/*
 * @Description: 仅保留登录相关接口
 */
import { get, post as purePost } from './request';

export const service = {
  // 腾讯云 OAuth 登录 - 获取授权跳转 URL（state 从当前页面 URL 获取）
  getTcOAuthAuthorizeUrl: (data) => {
    const state = new URLSearchParams(window.location.search).get('state') || '';
    return get(`/tc-oauth/authorize-url?state=${encodeURIComponent(state)}`, data);
  },
  // 腾讯云 OAuth 登录 - 授权码回调
  tcOAuthCallback: (data) => purePost('/tc-oauth/callback', data)
};
